module.exports = __webpack_public_path__ + "5c3d3eb8e0edf14c5674012803e7eec6.png";